<template>

  <v-flex xs12 sm12 md12 lg12 xl12>
    <Navbar></Navbar>
    <v-container class="">

      <v-layout row wrap>
        <v-flex sm4 md4 lg3 class="pl-1 ml-4 pt-5" >
          <v-card style="background-color:#2275BF">
            <v-card-title>
              <span class="titlevideos" style="color:white; font-family:Poppins;  font-weight:600">COREOGRAFIAS</span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex md1 class="pt-5" >
          <v-card flat style="background-color:#D6D6D6">
            <img src="COREOGRAFIAS.png"  style="position:absolute;margin-left:-30px; margin-top:-4px;z-index:1" />
          </v-card>
        </v-flex>

        <v-spacer></v-spacer>
        <v-flex xs12 sm4 md4 lg6>
          <v-text-field 
            class="pt-2 mt-4 pa-3 hidden-sm-and-md" 
            solo  
            label="Buscar Coreografia"  
            v-model="searchcoreografia" 
            prepend-inner-icon="search"
            style="width:75%;" >
          </v-text-field>
        </v-flex> 
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm6 md6 lg6 v-for="coreografia in filterCoreografias" :key="coreografia.title">
          <v-card flat class=" pa-4 " style="background-color:#D6D6D6" >
            <v-layout row wrap>
              <v-flex md12>
              <!--<v-layout :class="`actividad ${capacitacion.actividad}`">-->
                <v-card-title class="temavideo">
                  <div class="text-xs-center">
                    <span>{{coreografia.title}}</span>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>

            <v-img :src="coreografia.img" width="100%">
              <div class="center">
                <Reproductor2 :capacitacion="coreografia">
                </Reproductor2>
              </div>
            </v-img>  
          </v-card>
        </v-flex>      
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
  import Navbar from "@/components/Navbar.vue"  
  import Reproductor2 from "@/components/ReproductorVideos.vue"
 
  export default {
   

    components:{
       Navbar,Reproductor2
     },
    data(){
      return{
        searchcoreografia:"",
        dialog:false,
        coreografias:[
          
          {tema:"1",title:"Lalabumers en acción",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion01_Lalabumers_en_Accion.mp4"},
          {tema:"2",title:"Soy un Lalabumer",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion02_Soy_un_Lalabumer.mp4"},
          {tema:"3",title:"Buen día Lalabumer",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion03_Buen_Dia_Lalabumer.mp4"},
          //{tema:"4",title:"Una soluciónLalabum",img:"solucion_lalabum.png",url:"https://www.lalabumapp.com/descargas/videos/una_solucion_lalabum.mp4"},
          {tema:"5",title:"Mis amigos Lalabumers",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion05_Mis_Amigos_Lalabumers.mp4"},
          {tema:"6",title:"Me cuido como Lalabumer",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion06_Me_Cuido_Como_Lalabumer.mp4"},
          {tema:"7",title:"Mueve tus pies Lalabumer",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Cancion07_Mueve_Tus_Pies_Lalabumer.mp4"},
          {tema:"8",title:"Amigos del mundo Lalabum",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Amigos_del_mundo_Lalabum.mp4"},
          {tema:"9",title:"Mueve tus pies Lalabumer",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/Mueve_tus_pies_Lalabumer.mp4"},
          {tema:"9",title:"Lo intento otra vez",img:"Portada_coreografia.png",url:"https://www.lalabumapp.com/descargas/coreografias/LO_INTENTO_OTRA_VEZ_LALABUM.mp4"},

        ]
      }
    },
    computed: {
      filterCoreografias: function(){
        if (this.searchcoreografia=="") {
          return this.coreografias
        }else{
          return this.coreografias.filter((coreografia)=>{
            var expresion = new RegExp(this.searchcoreografia,"i")
            return coreografia.title.match(expresion)
          })
        }      
      }
  },
  methods:{
    
    mostrar: function(cap) {
            this.$refs.repo.setContent(cap)
            this.dialog=true
            //this.dialog_capacitacion=cap
        },   

      close: function(){

      }
  }
    
  }
</script>


<style scoped >

.temavideo{
    background-color:#2275BF; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;
  }
  
/*@media (min-width: 1200px)and (max-width: 1300px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -80px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 125px;
  }
}*/

/*@media (min-width: 1300px)and (max-width: 1800px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -90px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 150px;
  }
}*/

/*@media (min-width: 1800px) and (max-width: 2000px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:70%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -95px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 155px;
  }
}*/

/*@media (min-width: 2000px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:65%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -135px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 245px;
  }
}*/


@media (min-width: 750px){
  .temavideo{
    font-size: 1.5vw; 
    
  }
  }

  /*@media (min-width: 750px) and (max-width: 1000px){
    input[type=text] {
    background-color:white;
    width:90%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    margin-left: -50px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: -106px;
  }
  }*/

  /*@media (min-width: 1000px) and (max-width: 1200px){
     input[type=text] {
    background-color:white;
    width:90%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    float: right;
    margin-right: -65px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: 40px;
  }
  }*/

  @media (min-width: 300px) and (max-width: 750px){
    .temavideo{
    font-size: 4.5vw; 
    
  }

  /*input[type=text] {
    background-color:white;
    width:60%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    top:-30px;
    margin-left: 50px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: -8px;
    
  }*/
  }

.playvideo:hover {
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }

  .center {
  position:absolute; 
  top: 50%;
  left:50%;
  margin-top: -50px; 
  margin-left: -30px;
  }
</style>
